/**
 * Registry de brands soportados en runtime.
 *
 * Cada entry mapea un `brandCode` (string que devuelve la API en
 * `BrandingConfig.brandCode`) a los recursos bundleados en el app:
 *  - logo y color del splash overlay (web assets)
 *  - nombre del alternate icon iOS (declarado en Info.plist)
 *  - nombre del activity-alias Android (declarado en AndroidManifest.xml)
 *
 * Si la API devuelve un brandCode que no está en este registry, el
 * resolver cae automáticamente a `DEFAULT_BRAND` y no hay crash.
 *
 * Este archivo es patcheado automáticamente por el script
 * `tools/generate-brand-assets.js` cuando se agrega un brand nuevo.
 * Editá a mano solo si sabés lo que hacés.
 */

export interface BrandRegistryEntry {
  brandCode: string;
  splashLogoPath: string;
  backgroundColor: string;
  /** Nombre que debe coincidir con la key en CFBundleAlternateIcons del Info.plist. `null` = volver al primary icon. */
  iosAlternateIconName: string | null;
  /** Nombre completo del component (ej: '.aliases.Default'). `null` = usar el alias default. */
  androidAliasName: string | null;
}

export const DEFAULT_BRAND: BrandRegistryEntry = {
  brandCode: 'default',
  splashLogoPath: 'assets/brands/default/splash-logo.svg',
  backgroundColor: '#FFFFFF',
  iosAlternateIconName: null,
  androidAliasName: '.aliases.Default',
};

export const BRANDS_REGISTRY: BrandRegistryEntry[] = [
  // BRANDS_REGISTRY_START
  {
    brandCode: 'goldenstatewarriors',
    splashLogoPath: 'assets/brands/goldenstatewarriors/splash-logo.svg',
    backgroundColor: '#1D428A',
    iosAlternateIconName: 'AppIcon-Goldenstatewarriors',
    androidAliasName: '.aliases.Goldenstatewarriors',
  },
  // BRANDS_REGISTRY_END
];
